import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Card } from './ui/Card';
import { Reveal } from './ui/Reveal';
import { Globe, TrendingUp, Truck, AlertTriangle, ShieldCheck, BarChart3, RefreshCw, Activity, Users, Database, Target, DollarSign } from 'lucide-react';
const competencies = [{
  name: 'Enterprise Operations',
  icon: Globe
}, {
  name: 'Strategic Planning',
  icon: TrendingUp
}, {
  name: 'Supply Chain Optimization',
  icon: Truck
}, {
  name: 'Crisis Leadership',
  icon: AlertTriangle
}, {
  name: 'Governance & Oversight',
  icon: ShieldCheck
}, {
  name: 'Risk Management',
  icon: BarChart3
}, {
  name: 'Program Modernization',
  icon: RefreshCw
}, {
  name: 'Operational Resilience',
  icon: Activity
}, {
  name: 'Public-Private Partnerships',
  icon: Users
}, {
  name: 'Enterprise Digitization',
  icon: Database
}, {
  name: 'Performance & KPI Leadership',
  icon: Target
}, {
  name: 'Cost Optimization',
  icon: DollarSign
}];
export function CompetenciesSection() {
  return <Section id="competencies" variant="charcoal" data-id="element-74">
      <SectionHeader title="Core Competencies" subtitle="Areas of Expertise" data-id="element-75" />

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-76">
        {competencies.map((item, index) => <Reveal key={index} delay={index * 50} data-id="element-77">
            <Card className="h-full flex flex-col items-center justify-center text-center p-6 hover:bg-navy-800 transition-colors group" data-id="element-78">
              <div className="w-12 h-12 rounded-full bg-navy-900 border border-gold-500/30 flex items-center justify-center mb-4 group-hover:border-gold-500 group-hover:shadow-[0_0_15px_rgba(197,165,90,0.2)] transition-all" data-id="element-79">
                <item.icon className="text-gold-500 w-6 h-6" data-id="element-80" />
              </div>
              <h3 className="text-white font-heading font-medium uppercase tracking-wider text-sm" data-id="element-81">
                {item.name}
              </h3>
            </Card>
          </Reveal>)}
      </div>
    </Section>;
}